import React, { useState, useEffect } from "react";
import InputField from "../../components/InputField";
import Switch from "../../components/Switch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import ToolTip from "../ToolTip";
import Dropdown from "../Dropdown";

/** The production user form (commit 370850a), used by LegacyEditUserPage. */
const LegacyUserForm = ({
  user,
  setUser,
  setHasChanges,
  billingGroups,
  roles,
  onBillingGroupChange,
}) => {
  const selectedBillingGroup = user?.billingGroupName || "";
  const [selectedRole, setSelectedRole] = useState("");

  useEffect(() => {
    if (user?.roleName) {
      setSelectedRole(user?.roleName || "");
    }
  }, [user, roles]);

  return (
    <>
      {/* Two-column layout */}
      <div className="grid grid-cols-2 gap-6 w-full">
        {/* Column 1 */}
        <div className="flex flex-col gap-4">
          <Dropdown
            label="Billing group"
            value={selectedBillingGroup}
            options={billingGroups.map((group) => group.name)}
            onSelect={(option) => {
              onBillingGroupChange(option);
              setHasChanges(true);
            }}
            disabled={false}
          />

          <InputField
            label="Country"
            placeholder="Country"
            value={user?.country || ""}
            onChange={(e) => {
              setUser((s) => ({ ...s, country: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={true}
          />

          <InputField
            label="Licenses"
            placeholder="Licenses"
            value={
              user?.licenses
                ? Object.values(user?.licenses).join(", ")
                : "No licenses"
            }
            onChange={(e) => {
              setUser((s) => ({ ...s, licenses: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={true}
          />

          <InputField
            label="Display name"
            placeholder="Display name"
            value={user?.displayName || ""}
            onChange={(e) => {
              setUser((s) => ({ ...s, displayName: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={true}
          />

          <InputField
            label="Email"
            placeholder="Email"
            value={user?.email || ""}
            onChange={(e) => {
              setUser((s) => ({ ...s, email: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={true}
          />

          <InputField
            label="Last login"
            placeholder="Last signed in date"
            value={user?.lastSignInDateTime || ""}
            onChange={(e) => {
              setUser((s) => ({ ...s, lastSignedInDate: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={true}
          />

          <InputField
            label="Manager"
            placeholder="Manager"
            value={user?.managerDisplayName || ""}
            onChange={(e) => {
              setUser((s) => ({ ...s, managerDisplayName: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={true}
          />

          <div className="flex flex-col w-1/2">
            <label className="text-sm font-bold pb-2">On-premises sync</label>
            <div className="flex items-center space-x-2">
              <Switch
                checked={user?.accountEnabled}
                onChange={(checked) => {
                  setUser((s) => ({ ...s, accountEnabled: checked }));
                  setHasChanges(true);
                }}
                disabled={true}
              />
              <p className="text-sm">Sync</p>
            </div>
          </div>
        </div>

        {/* Column 2 */}
        <div className="flex flex-col gap-4">
        <Dropdown
            label="Role"
            value={user?.roles?.[0] || ""}
            options={roles} 
            onSelect={(option) => {
              setUser((prev) => ({
                ...prev,
                roles: [option], 
              }));
              setHasChanges(true);
            }}
            disabled={false}
          />

          <div className="flex flex-col">
            <label className="text-sm font-bold flex space-x-2">
              <span>User principal name</span>
              <ToolTip text={"This is the email address of the user"}>
                <FontAwesomeIcon
                  icon={faInfoCircle}
                  className="text-gray-400 text-md"
                />
              </ToolTip>
            </label>

            <InputField
              placeholder="User principal name"
              value={user?.userPrincipalName || ""}
              onChange={(e) => {
                setUser((s) => ({ ...s, userPrincipalName: e.target?.value }));
                setHasChanges(true);
              }}
              readOnly
              className="w-full"
              disabled={true}
            />
          </div>

          <InputField
            label="Updated by"
            placeholder="Updated by"
            value={user?.updatedBy || ""}
            onChange={(e) => {
              setUser((s) => ({ ...s, updatedBy: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={true}
          />

          <InputField
            label="Last update"
            placeholder="Last update"
            value={user?.updatedDate || ""}
            onChange={(e) => {
              setUser((s) => ({ ...s, updatedDate: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={true}
          />

          <InputField
            label="Account type"
            placeholder="Account type"
            value={user?.accountTypeName || ""}
            onChange={(e) => {
              setUser((s) => ({ ...s, accountTypeName: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={true}
          />

          <InputField
            label="Phone"
            placeholder="Phone"
            value={user?.mobilePhone || ""}
            onChange={(e) => {
              setUser((s) => ({ ...s, mobilePhone: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={true}
          />

          <InputField
            label="Office location"
            placeholder="Office location"
            value={user?.officeLocation || ""}
            onChange={(e) => {
              setUser((s) => ({ ...s, officeLocation: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={true}
          />
        </div>
      </div>
    </>
  );
};

export default LegacyUserForm;
